const reviewer = [
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
];

export default reviewer;
